import { downloadFile } from '../utils/utils';
import { downloadDueWitSupportingDocuments } from '../service/api/dues.api';

export default {
    methods: {
        async downloadDocument(documentName) {
            await downloadFile({
                content: this.formData[documentName]
            });
        },
        async downloadDuePdf() {
            try {
                this.downloadDueIsLoading = true;
                await downloadDueWitSupportingDocuments(this.due.id);
                this.downloadDueIsLoading = false;
            } catch ({ response }) {
                this.downloadDueIsLoading = false;
            }
        }
    }
}
